import gql from 'graphql-tag';

export const updateCategory = gql`
  mutation updateCategory($input: UpdateCategoryInput!){
    updateCategory(input: $input){
      id
    }
  }
`;
